import Products from "./Products";
export default () => {
  const navigation = [
    { title: "Customers", path: "javascript:void(0)" },
    { title: "Careers", path: "javascript:void(0)" },
  ];

  return (
    <>
      <Products />
    </>

  );
};


